// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1UU_b","search":"Settings_search__16p7P","filter":"Settings_filter__1NrSY"};